<template>
  <div class="new-project-bundles">
    <div class="main-container">
      <div
        :class="{ active: bundle.data === pB.AUTOMATIC }"
        class="bundle-block auto"
        @click="setBundleData(pB.AUTOMATIC)"
      >
        <div class="title">{{ $t('project.bundle.automatic') }}</div>
        <div class="description">
          <coming-soon />
          <p>{{ $t('newProject.bundle.automatic.description') }}</p>
        </div>
      </div>
      <div :class="{ active: bundle.data === pB.MANUAL }" class="bundle-block manual" @click="setBundleData(pB.MANUAL)">
        <div class="title">{{ $t('project.bundle.manual') }}</div>
        <div class="description">
          <p>{{ $t('newProject.bundle.manual.description') }}</p>
        </div>
      </div>
      <div
        :class="{ active: bundle.data === pB.CYNERGY }"
        class="bundle-block cynergy"
        @click="setBundleData(pB.CYNERGY)"
      >
        <div class="title">{{ $t('project.bundle.cynergy') }}</div>
        <div class="description">
          <coming-soon />
          <p>
            {{ $t('newProject.bundle.cynergy.description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { projectBundles } from '@/constants/projects';

import ComingSoon from '@/components/common/ComingSoon.vue';

export default {
  name: 'NewProjectBundles',
  components: {
    ComingSoon,
  },
  props: {
    newProject: Object,
  },
  data() {
    return {
      bundle: this.newProject.projectBundlesData,
    };
  },
  computed: {
    pB() {
      return projectBundles;
    },
  },
  watch: {
    newProject: {
      deep: true,
      handler() {
        this.$emit('setRequiredDataForStep', 4);
      },
    },
  },
  methods: {
    setBundleData(/* bundle */) {
      // this.bundle.data = bundle;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.new-project-bundles {
  display: flex;

  .main-container {
    width: rem(698);
    height: rem(289);
    display: block;
    position: relative;
    margin: rem(100) rem(99) rem(244);

    .active {
      margin-top: 0;
      background-color: var(--brand-primary);
      color: #ffffff;
      bottom: rem(10);
      position: relative;
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);

      .title {
        color: #ffffff;
      }
    }

    .bundle-block {
      cursor: pointer;
      display: inline-block;
      width: rem(222);
      height: rem(433);
      border-radius: $radius-lg;
      border: solid 1px var(--border-primary);
      margin-top: $space-2;

      .description {
        p {
          color: var(--text-tertiary);
          font-size: $font-size-sm;
          letter-spacing: 0;
          line-height: rem(18);
        }
      }

      &.active {
        .description {
          p {
            color: #ffffff;
            font-size: $font-size-sm;
            letter-spacing: 0;
            line-height: rem(18);
          }
        }
      }
    }

    .title {
      font-size: $font-size-md;
      text-transform: uppercase;
      font-weight: bold;
      display: block;
      margin-top: rem(36);
      text-align: center;
      color: var(--text-muted);
    }

    .description {
      display: table;
      margin-top: rem(15);
      margin-left: rem(32);
      margin-right: rem(32);
      text-align: center;
      font-size: rem(11);

      .coming-soon {
        margin: rem(5) 0;
      }
    }

    .manual {
      margin-left: $space-4;
      margin-right: $space-4;
    }
  }
}
</style>
